//
// GENERATED by KVision
//
package pl.finn.forms.swz

import org.w3c.fetch.RequestInit
import io.kvision.remote.KVRemoteAgent
import kotlinx.serialization.modules.SerializersModule
import pl.finn.forms.Zalacznik
import pl.finn.forms.swz.SwzForm
import pl.finn.forms.swz.SwzFormData

actual class SwzService(serializersModules: List<SerializersModule>? = null, requestFilter: (suspend RequestInit.() -> Unit)? = null) : ISwzService, KVRemoteAgent<SwzService>(SwzServiceManager, serializersModules, requestFilter) {
    override suspend fun nowy(token: String) = call(ISwzService::nowy, token)
    override suspend fun edycja(token: String) = call(ISwzService::edycja, token)
    override suspend fun sprawdz(swzForm: SwzForm, zalaczniki: List<Zalacznik>, token: String) = call(ISwzService::sprawdz, swzForm, zalaczniki, token)
    override suspend fun zapisz(swzForm: SwzForm, zalaczniki: List<Zalacznik>, validateResult: String?, token: String) = call(ISwzService::zapisz, swzForm, zalaczniki, validateResult, token)
    override suspend fun podglad(swzForm: SwzForm, zalaczniki: List<Zalacznik>, token: String) = call(ISwzService::podglad, swzForm, zalaczniki, token)
}
